import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';

export const AlreadyAuthenticatedGuard: CanActivateFn = () => {
  const router = inject(Router);
  const oktaAuth = inject(OKTA_AUTH);

  const isAuthenticated = !!oktaAuth.getAccessToken();
  return isAuthenticated ? router.createUrlTree(['/']) : true;
};
